




























































import {Component, Mixins} from 'vue-property-decorator';
import SettingsTabMixin from '@/mixins/settings/SettingsTabMixin';
import CNumberField from '@/components/base/numberField/CNumberField.vue';
import CTable from '@/components/base/table/CTable.vue';
import CSelect from '@/components/base/select/CSelect.vue';
import DescriptionsContainerMixin from '@/mixins/DescriptionsContainerMixin';
@Component({
    components: {CSelect, CTable, CNumberField},
})
export default class MaterialExpenseRatio extends Mixins(SettingsTabMixin, DescriptionsContainerMixin) {
    get tableHeaders() {
        return [
            {
                value: 'IdPlywoodThickness',
                text: this.$t('Catalogues.Plywoods.PlywoodThickness.NameSingle'),
                sort: this.getDescriptionsContainer().getSortFn(
                    this.addDescriptionPostfix(this.$api.catalogues.plywoodThickness),
                ),
            },
            {
                value: 'ExpenseRatio',
                text: this.$t('Systems.Settings.VeneerExpenseRatio'),
            },
        ];
    }
}
